(function () {
  document.querySelectorAll(".klar-feature-slider").forEach(function (section) {
    var sectionId = section.id.replace("klar-section-", "");
    var track = document.getElementById("klar-fs-track-" + sectionId);
    var dotsWrap = document.getElementById("klar-fs-dots-" + sectionId);
    if (!track || !dotsWrap) return;

    var cards = Array.from(
      track.querySelectorAll(".klar-feature-slider__card"),
    );
    var dots = Array.from(
      dotsWrap.querySelectorAll(".klar-feature-slider__dot"),
    );
    var activeIndex = 0;

    function setActive(index) {
      if (index < 0 || index >= cards.length) return;
      activeIndex = index;
      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === activeIndex);
      });
    }

    // Dot click → scroll card into view
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        var card = cards[i];
        if (!card) return;
        track.scrollTo({
          left: card.offsetLeft - track.offsetLeft,
          behavior: "smooth",
        });
      });
    });

    // Update active dot on scroll
    var scrollTimer;
    track.addEventListener("scroll", function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var trackLeft = track.getBoundingClientRect().left;
        var closest = 0;
        var minDist = Infinity;
        cards.forEach(function (card, i) {
          var dist = Math.abs(card.getBoundingClientRect().left - trackLeft);
          if (dist < minDist) {
            minDist = dist;
            closest = i;
          }
        });
        setActive(closest);
      }, 50);
    });
  });
})();
